import React from "react";
import GeneralToolsActionGroup from "./GeneralToolsActionGroup";
import Diagnostic from "./Diagnostic";
import LayoutContent from "../../LayoutContent";
import ToolsNavSubMenu from "../ToolsNavSubMenu";
import Header from "../../Header/Header";
import Breadcrumb from "../../Header/Breadcrumb";
import HeaderButton from "../../Header/HeaderButton";
import IconDebug from "../../../Icons/TopCommandPanel/Debug";

export default function GeneralAndDiagnostic() {
  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[
              {
                title: "General",
                to: "/tools/store-and-retrieve",
                disabled: false,
              },
            ]}
          />
          <Header.RightSide>
            <HeaderButton
              id={"DEBUG_PAGE"}
              label="Debug"
              icon={<IconDebug />}
              onClick={(id) => {
                window.open("/debug", "debugpage");
              }}
            />
          </Header.RightSide>
        </Header>
      </LayoutContent.Header>
      <LayoutContent.SubMenu>
        <ToolsNavSubMenu />
      </LayoutContent.SubMenu>
      <LayoutContent.Content style={{paddingTop: 0}}>
        <div
          style={{
            display: "flex",
            height: "100%",
          }}
        >
          <GeneralToolsActionGroup
            style={{
              width: "33.84%",
              borderRight: "1px solid #9E9E9E",
            }}
          />
          <Diagnostic
            style={{
              width: "66.16%"
            }}
          />
        </div>
      </LayoutContent.Content>
    </LayoutContent>
  );
}
